import { CommonData } from '../common_schema'

export const connectionData: CommonData[] = [
  {
    name: 'Connection Count(total)',
    mean: 'Connnection_count:total.values.mean',
    std: 'Connnection_count:total.values.std',
    location: 'Performance Overview --> Connection Count'
  },
  {
    name: 'Connection Count(active)',
    mean: 'Active_connection_count:total.values.mean',
    std: 'Active_connection_count:total.values.std',
    location: 'Performance Overview --> Connection Count'
  },
  {
    name: 'Connection Count(delta between TiDB)',
    mean: 'Connnection_count_detla:total.values.mean',
    std: 'Connnection_count_detla:total.values.std',
    location: 'TiDB-Details --> Servers --> Connection Count'
  },
  {
    name: 'Get Token Duration(p99)',
    mean: 'P99_get_token_duration:total.values.mean',
    std: 'P99_get_token_duration:total.values.std',
    location: 'TiDB-Details --> Servers --> Get Token Duration'
  },
  {
    name: 'Queries Using Plan Cache OPS(total)',
    mean: 'Plan_cache_OPS:total.values.mean',
    std: 'Plan_cache_OPS:total.values.std',
    location: 'Performance Overview --> Queries Using Plan Cache OPS'
  },
  {
    name: 'Plan Cache Miss(total)',
    mean: 'Plan_cache_miss_OPS:total.values.mean',
    std: 'Plan_cache_miss_OPS:total.values.std',
    location: 'TiDB-Details --> Executor --> Plan Cache Miss OPS'
  },
  {
    name: 'Prepare Statement Count(total)',
    mean: 'Prepare_Statement_count:total.values.mean',
    std: 'Prepare_Statement_count:total.values.std',
    location: 'TiDB-Details --> Server  --> Prepare Statement Count'
  }
]
